import { GraphQLID, GraphQLNonNull, GraphQLString } from 'graphql'

export interface LibraryQueryArgs {
  readonly organizationID: string
  readonly hash: string
  readonly language: string
}

export const libraryQueryArgsType = {
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  hash: {
    description: 'The sha1 hash of the Library being queried',
    type: new GraphQLNonNull(GraphQLString)
  },
  language: {
    description:
      'The language or framework the Library is made for (e.g. Java, Ruby)',
    type: new GraphQLNonNull(GraphQLString)
  }
}
